import { render, staticRenderFns } from "./NoticeOfLeave.vue?vue&type=template&id=33e783b8&scoped=true&"
import script from "./NoticeOfLeave.vue?vue&type=script&lang=ts&"
export * from "./NoticeOfLeave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e783b8",
  null
  
)

export default component.exports